import type { BrowserInfo, StorageEstimate } from '@/types/Diagnostics';

export abstract class DiagnosticsService {
  /**
   * Read the origin's storage usage and quota via `navigator.storage.estimate()`.
   * Returns zeroed bytes when the Storage API is unavailable.
   */
  abstract getStorageEstimate(): Promise<StorageEstimate>;

  /**
   * Read browser/environment info from `navigator` and `window`.
   */
  abstract getBrowserInfo(): BrowserInfo;
}
